import { DeviceBrandId, DeviceBrandName } from "models/ISensor";
import { ISensorType } from "models/ISensorType";
import { getProviderLabel } from "helpers/ProviderStylesHelper";

export const getDeviceBrandName: (deviceBrandId: string) => string = (deviceBrandId: string) => {
    switch (deviceBrandId) {
        case DeviceBrandId.WoePal:
            return DeviceBrandName.WoePal;
        case DeviceBrandId.WAQI:
            return DeviceBrandName.WAQI;
        case DeviceBrandId.Flow:
            return DeviceBrandName.Flow;
        case DeviceBrandId.Fitbit:
            return DeviceBrandName.Fitbit;
        case DeviceBrandId.CapMedic:
            return DeviceBrandName.CapMedic;
        case DeviceBrandId.SakuraTech:
            return DeviceBrandName.SakuraTech;
        case DeviceBrandId.inBiot:
            return DeviceBrandName.inBiot;
        case DeviceBrandId.AwarenessApp:
            return DeviceBrandName.AwarenessApp;
        case DeviceBrandId.DSS2:
            return DeviceBrandName.DSS2;
        case DeviceBrandId.CEMIC:
            return DeviceBrandName.CEMIC;
        case DeviceBrandId.PolitoAndSAT:
            return DeviceBrandName.PolitoAndSAT;
        case DeviceBrandId.Sykno:
            return DeviceBrandName.Sykno;
        case DeviceBrandId.Anura:
            return DeviceBrandName.Anura;
        case DeviceBrandId.URVMINOS:
            return DeviceBrandName.URVMINOS;
        case DeviceBrandId.enControl:
            return DeviceBrandName.enControl;
        case DeviceBrandId.COMPASSApp:
            return DeviceBrandName.COMPASSApp;
        case DeviceBrandId.Garmin:
            return getProviderLabel("garmin");
        case DeviceBrandId.Polar:
            return getProviderLabel("polar");
        case DeviceBrandId.Suunto:
            return getProviderLabel("suunto");
        case DeviceBrandId.Whoop:
            return getProviderLabel("whoop");
        case DeviceBrandId.Strava:
            return getProviderLabel("strava");
        case DeviceBrandId.Oura:
            return getProviderLabel("oura");
        case DeviceBrandId.FitbitOW:
            return getProviderLabel("fitbit");
        case DeviceBrandId.Ultrahuman:
            return getProviderLabel("ultrahuman");
        case DeviceBrandId.Apple:
            return getProviderLabel("apple");
        case DeviceBrandId.Samsung:
            return getProviderLabel("samsung");
        case DeviceBrandId.Google:
            return getProviderLabel("google");
        default:
            return "Unknown";
    }
};

export const getSensorTypeName = (sensorTypeId: string, sensorTypes: ISensorType[], t: (key: string, fallback: string) => string): string => {
    const sensorType = sensorTypes.find(st => st.id === sensorTypeId);
    if (!sensorType) return sensorTypeId;
    return t(sensorType.key, sensorType.key);
};

